// src/api/auth.js
import http from './http';

export async function register(payload) {
  const { data } = await http.post('/api/auth/register', payload);
  return data;
}

export async function login(email, password) {
  const { data } = await http.post('/api/auth/login', { email, password });
  return data;
}

export async function verifyEmail(token, email) {
  const { data } = await http.post('/api/auth/verify-email', { token, email });
  return data;
}

export async function resendVerification(email) {
  const { data } = await http.post('/api/auth/resend-verification', { email });
  return data;
}

export async function forgotPassword(email) {
  const { data } = await http.post('/api/auth/forgot-password', { email });
  return data;
}

export async function resetPassword({ email, token, newPassword }) {
  const { data } = await http.post('/api/auth/reset-password', { email, token, newPassword });
  return data;
}

export const csrf = () => http.get('/api/auth/csrf');
